
<template>
  <div>
    <main class="main">
      <RemindText />
      <div class="container client_container">
        <div class="clients_course">
          <div class="course_photo">
            <img v-bind:src="imgCover" class="course_img">
          </div>
          <div class="course_info">
            <h1 class="course_info_title">{{this.title}}</h1>
            <p class="course_info_subtitle">{{this.subtitle}}</p>
            <div class="course_info_author">
              <div class="author_img"><img v-bind:src="author_imgAvatar" ></div>
              <div class="author_name">{{this.author_title}}</div>
            </div>
            <div class="course_info_course_totel">
              <div class="course_totel">
                {{ total }} 集
              </div>
            </div>
            <div class="course_info_group">
              <div class="course_info_totel">
                <div class="total">
                  <div v-show="courseTotal !== 99999" class="text-main total_text">
                    可借聽數 {{ borrowQuantity }} / 共 {{ courseTotal }}
                  </div>
                </div>
                <div class="course_info_btnGroup">
                  <div v-show="!isMobile" class="course_info_borrowNow">
                    <div
                      v-show="isLoading" class="borrow_status loading_status"
                    >
                      <img src="@/assets/images/loading_icon.svg" alt="loading" class="loading_icon">
                    </div>
                    <div
                      v-if="!isCanBorrow || borrowErrorText !== '' || isBorrowReachedTheLmit
                      "
                      class="borrow_status disable"
                    >
                      <p class="disable_text">
                        立即借聽
                      </p>
                    </div>
                    <!-- || this.borrowQuantity === 0 -->
                    <div
                      v-if="isCanBorrow && !isBorrowed && borrowErrorText === '' &&
                      !isBorrowReachedTheLmit"
                      @click="borrowNow" class="borrow_btn"
                    >
                      立即借聽
                    </div>
                    <!-- && this.borrowQuantity !== 0 -->
                    <div
                      v-if="isCanBorrow && isBorrowed"
                      @click="returnBorrow" class="borrow_btn"
                    >
                      歸還
                    </div>
                    <div
                      v-if="borrowErrorText !== ''" class="error_text"
                    >
                      {{ borrowErrorText }}
                    </div>
                  </div>
                  <div
                  :class="{ 'resetPadding': isMobile }"
                  class="course_info_borrowByApp">
                    <div v-show="!isAppUserAgent" class="appOpen_btn">
                      <a v-bind:href="clientsQRCode" class="appOpen_link mobile_btn"><span class="appOpen_btn_icon"><img src="@/assets/images/clients/icon_mobilenew_white.svg" alt="在App借聽"></span>在 App 借聽</a>
                      <div class="appOpen_link pc_btn" @click="openModel">在 App 借聽</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="course_info_share">
                <ShareNetwork
                  network="facebook"
                  :url= pageUrl
                  title=""
                  description=""
                  quote=""
                  hashtags="一刻鯨選"
                  tag="div"
                  class="fb share_item"
                >
                  <div class="share_icon"><img src="@/assets/images/icon_share_fb.png" alt="分享"></div>
                  <a href="javascript:void(0)" class="share_link">分享</a>
                </ShareNetwork>

                <ShareNetwork
                  network="line"
                  :url= pageUrl
                  title=""
                  description=""
                  quote=""
                  hashtags=""
                  tag="div"
                  class="line share_item"
                >
                  <div class="share_icon"><img src="@/assets/images/icon_share_line.png" alt="分享"></div>
                  <a href="javascript:void(0)" class="share_link">分享</a>
                </ShareNetwork>

              </div>
            </div>

          </div>
        </div>
        <div ref="bodyCourse" class="bodyContent bodyCourse">
          <div ref="course_tabs" class="course_tabs">
            <ul>
              <li
                :class="{ 'tab_active': tabIndex === 1 }"
                @click= "tabIndex = 1"
              >課程簡介</li>
              <li
                :class="{ 'tab_active': tabIndex === 2 }"
                @click= "tabIndex = 2"
              >音頻列表</li>
            </ul>
          </div>
          <div v-show="tabIndex === 1" class="course_introduction">
            <div v-if="publisher!=null" class="publisher"><p v-html="publisher"></p></div>
            <section class="uploadArea intro">
              <h2>課程簡介</h2>
              <span v-html="description"></span>
            </section>
            <!-- <section class="demo" v-show="checkAuditionVideosList">
              <h2>試聽內容</h2>
              <ul>
                <li v-for = "audition_videos in audition_videos_list" :key="audition_videos.id">

                  <p v-if="isMobile"><a data-fancybox target="_blank" v-bind:href="youtube_url+ audition_videos.video" class="playBtn">播放</a></p>

                  <p v-if="!isMobile"><a data-fancybox v-bind:href="youtube_url+ audition_videos.video" class="playBtn glightbox3">播放</a></p>

                  <p>{{audition_videos.title}}</p>
                </li>
              </ul>
            </section> -->

            <section class="uploadArea">
              <!-- <h2>分集大綱</h2> -->
              <div>
                <span v-html="descriptionHtml"></span>
              </div>
            </section>
          </div>
          <div v-show="tabIndex === 2" class="course_repertoire">
            <ul class="audio_list">
              <li
                v-for="(track, index) in paginationClassData"
                :key="track.id"
                :class="{'audio_disabled': track.free === false && isBorrowed === false || track.status === false,
                  'audio_bg_dark': !track.status
                }"
                class="audio_item"
              >
                  <div class="track_btn">
                    <button
                    @click="getAudio(track, index)"
                    :disabled="track.free === false && isBorrowed === false || track.status === false"
                    class="button"
                    >
                      <i
                        v-show="trackInfo.trackId !== track.id || !isPlaying"
                        class="fas fa-play"
                      ></i>
                      <i
                        v-show="trackInfo.trackId === track.id &&isPlaying"
                        class="fas fa-pause"
                      ></i>
                    </button>
                    <p v-show="track.free === true" class="audition_text">試聽</p>
                    <div
                      @click="showDisabledMessage"
                      v-show="track.free === false && isBorrowed === false || track.status === false"
                      class="click_disabled_message"
                    ></div>
                  </div>
                  <div class="track_content">
                    <div class="track_title">
                      <span>
                        {{track.num}}
                      </span>
                      {{track.title}}
                    </div>
                    <div v-if="track.status === true" class="track_right">
                        <div class="track_date">
                          {{ track.updated_at }}
                        </div>
                        <div class="track_length">
                          {{ track.timeLength }}
                        </div>
                    </div>
                    <div v-if="track.status === false" class="track_right">
                      內容將陸續更新
                    </div>
                  </div>
              </li>
            </ul>
            <div v-show="totalPages > 1" class="pagiContainer">
              <ClientsPagination
                :current-page.sync="currentPage"
                :total-pages="totalPages"
                v-on:change-list-page="changeListPage"
              />
            </div>
          </div>
        </div>
        <ClientsQRcode
          :share-link="pageUrl"
          :is-show-share-link="true"
        />
      </div>
    </main>

    <transition name='fade'>
      <div class="caption_modal" v-show="openQrcodeCaption">
        <div class="caption_wrap">
          <div class="caption_group">
            <div class="caption_close">
              <button type="button" class="close_btn" @click="closeCaption">
                <img src="@/assets/images/btn_close.png" class="close_icon" alt="close_icon">
              </button>
            </div>
            <div class="caption_qrcode">
              <img src="@/assets/images/clients/qrcode_decofocus.svg" alt="" class="qrcode_bg">
              <qrcode-vue :value="clientsQRCode" :size="210" level="H"></qrcode-vue>
            </div>
            <div class="caption_text">
              <p>掃描下載一刻鯨選 App</p>
              <p>享受完整聆聽服務</p>
            </div>
          </div>
        </div>

        <div class='client_overlay' @click="closeCaption"></div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import fancybox from '@/assets/vendor/fancybox-master/jquery.fancybox.min.js'

// eslint-disable-next-line no-unused-vars
import readmore from '@/assets/vendor/readmore/readmore.min.js'
// eslint-disable-next-line no-unused-vars
import functionJs from '@/assets/js/function.js'
// eslint-disable-next-line no-unused-vars
import pace from '@/assets/vendor/pace/js/pace.min.js'

// let glightbox = require('@/assets/vendor/glightbox-master/glightbox.min.js')
import { mapState, mapActions } from 'vuex'
import { borrowCourse, getBorrowRecords, getClientCourseData, returnBorrowCourse } from '@/api/toB'
import { getClientAudioList } from '@/api/audio'
import { parseDate, parseTrackTime } from '@/utils/parseTime'
import QrcodeVue from 'qrcode.vue'
import RemindText from '../components/RemindText'
import ClientsQRcode from '../components/ClientsQRcode'
import ClientsPagination from '../components/ClientsPagination'

export default {
  name: 'ClientsCourse',
  metaInfo () {
    return {

      title: `${this.title} | ${this.clientTitle} | 一刻鯨選`,
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: `${this.title} | ${this.clientTitle} | 一刻鯨選` },
        { property: 'og:site_name', content: `${this.title} | ${this.clientTitle} | 一刻鯨選` },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.imgCover },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: this.meta_description }

      ]
    }
  },
  components: {
    ClientsQRcode,
    RemindText,
    QrcodeVue,
    ClientsPagination
  },
  props: ['clientsData'],
  computed: {
    toBChannelID () {
      let clientCourseId
      const courseList = this.clientAssets
      for (let i = 0; i < courseList.length; i++) {
        if (courseList[i].channel.id === this.channelID) {
          clientCourseId = courseList[i].id
          break
        }
      }
      return clientCourseId
    },
    isBorrowed () {
      let borrowed = false
      for (let i = 0; i < this.borrowRecord.length; i++) {
        if (this.borrowRecord[i].client_asset.channel_id === this.channelID) {
          borrowed = true
          break
        }
      }
      return borrowed
    },
    isBorrowReachedTheLmit () {
      if (this.borrowQuantity === 0 && !this.isBorrowed) {
        return true
      }
      return false
    },
    ...mapState({
      isMobile: state => state.isMobile,
      trackList: state => state.audio.trackList,
      courseInfo: state => state.audio.courseInfo,
      trackInfo: state => state.audio.trackInfo,
      cid: state => state.toB.cid,
      clientTitle: state => state.toB.clientTitle,
      clientAssets: state => state.toB.clientAssets,
      clientCourses: state => state.toB.clientCourses,
      borrowRecord: state => state.toB.borrowRecord,
      clientsQRCode: state => state.toB.clientsQRCode
    }),
    isPlaying: {
      get () {
        return this.$store.state.audio.isPlaying
      },
      set (value) {
        this.$store.commit('audio/setIsPlaying', value)
      }
    },
    isLoading: {
      get () {
        return this.$store.state.toB.isLoading
      },
      set (value) {
        this.$store.commit('toB/setIsLoading', value)
      }
    },
    isCanBorrow: {
      get () {
        return this.$store.state.toB.isCanBorrow
      },
      set (value) {
        this.$store.commit('toB/setIsCanBorrow', value)
      }
    },
    borrowErrorText: {
      get () {
        return this.$store.state.toB.borrowErrorText
      },
      set (value) {
        this.$store.commit('toB/setBorrowErrorText', value)
      }
    },
    shutDownPlayer: {
      get () {
        return this.$store.state.audio.shutDownPlayer
      },
      set (value) {
        this.$store.commit('audio/setShutDownPlayer', value)
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    courseTotal () {
      let courseTotal
      for (let i = 0; i < this.clientAssets.length; i++) {
        if (this.clientAssets[i].channel.id === this.channelID) {
          courseTotal = this.clientAssets[i].total_copy
        }
      }
      return courseTotal
    }

  },
  data () {
    return {
      classData: [],
      channelID: '',
      title: '', // 標題
      subtitle: '', // 副標題
      imgCover: '', // 圖片
      meta_description: '', // 描述(meta用)
      description: '',
      descriptionHtml: '', // 描述HTML
      target: '', // 適合對象
      total: '', // 總課堂數
      total_copy: null, // 可借聽數
      author: [], // 作者
      author_title: '', // 作者標題
      author_imgAvatar: '', // 作者圖片
      author_description: '', // 作者描述
      episodes_title: '', // 音頻標題
      episodes_summary: '', // 音頻大綱
      audition_videos_list: [], // 試聽影音
      publisher: '', // 出版方
      youtube_url: 'https://www.youtube.com/watch?v=',
      id: '0',
      shareURL: '',
      checkAuditionVideosList: true,
      pageUrl: '',
      lineShareValue: '',
      isAppUserAgent: false,
      openQrcodeCaption: false,
      tabIndex: 1,
      channel_episodes: [],
      borrowQuantity: 0,

      api_current_page: 1,
      currentPage: 1,
      totalPages: 1,
      paginationClassData: []

    }
  },
  watch: {
    toBChannelID: function (val) {
      this.getBorrowQuantity(val)
    },
    isBorrowReachedTheLmit: function (val) {
      if (val) {
        this.borrowErrorText = '借聽數已滿'
      } else {
        this.resetBorrowErrorText()
      }
    }
  },
  created () {
    var userAgent = navigator.userAgent

    if (userAgent.indexOf('jinfmapp') > -1) {
      this.isAppUserAgent = true
    }

    this.pageUrl = window.location.toString()
    if (this.pageUrl.includes('?')) {
      this.pageUrl = this.pageUrl.split('?')[0]
    }

    this.shareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.toString()

    const pathName = window.location.pathname
    var index = window.location.pathname.lastIndexOf('/')

    this.channelID = Number(pathName.substring(index + 1, pathName.length))
    // console.log(this.channelID)

    this.checkClientCourse()
    this.getAudioList()
    // console.log(this.clientCourses.indexOf(this.channelID) !== -1)
    this.resetBorrowErrorText()
  },
  mounted () {
    this.setQRCode(this.cid, this.channelID)
  },
  methods: {
    ...mapActions('audio', [
      'setAudioList',
      'setCourseInfo',
      'setTrackInfo'
    ]),
    ...mapActions('toB', [
      'setBorrowRecord'
    ]),
    strip_html_tags (str) {
      if ((str === null) || (str === '')) { return false } else { str = str.toString() }
      return str.replace(/<[^>]*>/g, '')
    },
    checkClientCourse () {
      console.log('checkClientCourse')
      // console.log(this.clientCourses)
      if (this.clientCourses.length === 0) {
        this.axios
          .get(`${this.$store.getters.baseURL}clients/${this.cid}`)
          .then(response => {
            if (response.status === 200) {
              // console.log(response.data)
              const clientAssets = response.data.client_blocks[0].client_assets

              const coursesIdList = clientAssets.map((clientAsset) => {
                return clientAsset.channel.id
              })
              // console.log(coursesIdList)

              coursesIdList.indexOf(this.channelID) !== -1 ? this.getClientCourse(this.channelID) : this.backClientIndex(this.cid)
            } else if (response.includes('404')) {
              this.$router.push(`/org/${cid}`)
            }
          })
          .catch(error => console.log('log:' + error))
      } else {
        this.clientCourses.indexOf(this.channelID) !== -1 ? this.getClientCourse(this.channelID) : this.backClientIndex(this.cid)
      }
    },
    getClientCourse (id) {
      this.axios
        .get(this.$store.getters.baseURL + 'channels/' + id)
        .then(response => {
          // console.log(response)
          this.classData = response.data
          this.imgCover = this.classData.imgCover
          this.total = this.classData.total
          this.author = this.classData.author
          this.author_imgAvatar = this.author.imgAvatar
          this.audition_videos_list = this.classData.audition_videos

          if (this.audition_videos_list.length === 0) {
            this.checkAuditionVideosList = false
          }
          this.getTW()
          this.meta_description = this.strip_html_tags(this.meta_description)
          this.lineShareValue = '【一刻鯨選】' + this.title + '\n' + ''

          if (this.title !== '') {
            this.getClientTitle()
          }
        })
        .catch(error => console.log('log:' + error))
    },
    getTW () {
      this.title = this.classData.title
      this.subtitle = this.classData.subtitle
      this.description = this.classData.description
      this.meta_description = this.classData.description
      this.descriptionHtml = this.classData.descriptionHtml
      this.target = this.classData.target
      this.author_title = this.author.title
      this.author_description = this.author.descriptionHtml
      this.publisher = this.classData.publisher
    },
    getClientTitle () {
      this.axios
        .get(`${this.$store.getters.baseURL}clients/${this.cid}`)
        .then(response => {
          const clientName = response.data.display_name
          this.gaPage(clientName)
        })
        .catch(error => console.log('log:' + error))
    },
    setQRCode (id, channelID) {
      const pageUrl = `${window.location.origin}/org/${id}/${channelID}`
      const QRCodeValue = `https://jinfm.page.link/?link=${pageUrl}&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm`
      this.$store.commit('toB/CLIENTS_QRCODE', QRCodeValue)
    },
    gaPage (name) {
      // ga
      this.$ga.page({
        page: `/org/${this.cid}/${this.channelID}`,
        title: `${this.title} | ${this.clientTitle} | 一刻鯨選`,
        location: window.location.href
      })
    },
    setYoutube (id) {
      this.youtube_url = this.youtube_url + id
    },
    // 切換Scroll效果
    stopScroll (val) {
      if (val) {
        this.$modalHelper.afterOpen()
      } else {
        this.$modalHelper.beforeClose()
      }
    },
    openModel () {
      this.openQrcodeCaption = true
      this.stopScroll(true)
    },
    closeCaption () {
      this.openQrcodeCaption = false
      this.stopScroll(false)
    },
    backClientIndex (cid) {
      this.$router.push(`/org/${cid}`)
    },
    // 重排課程列表
    sortClass (classData, type) {
      // console.log(classData, type);
      if (type === 'add') {
        this.paginationClassData = []
        this.allCount = classData.length
        this.totalPages = Math.ceil(classData.length / 10)
        // console.log(this.allCount)
        // console.log(this.totalPages)

        let size = classData.length
        if (classData.length > 10) {
          size = 10
        }
        for (let i = 0; i < size; i++) {
          this.paginationClassData.push(classData[i])
        }
      } else {
        if (this.api_current_page !== this.currentPage) {
          this.paginationClassData = []
          this.allCount = classData.length

          let i = (this.currentPage - 1) * 10

          if (this.allCount > this.currentPage * 10) { // 最多18筆
            this.allCount = this.currentPage * 10
          }

          for (i; i < this.allCount; i++) {
            this.paginationClassData.push(classData[i])
          }

          this.api_current_page = this.currentPage
          this.scrollToList()
        }
      }
    },
    // 接收子層currentPage後重排課程列表
    changeListPage (val) {
      this.currentPage = val
      this.sortClass(this.channel_episodes, 'update')
    },
    scrollToList () {
      console.log(this.$refs.bodyCourse.offsetTop)
      window.scrollTo({
        top: this.$refs.bodyCourse.offsetTop - 60,
        left: 0,
        behavior: 'smooth'
      })
    },

    async getAudioList () {
      // console.log(clientAssets)
      const pathName = window.location.pathname
      const index = pathName.lastIndexOf('/')
      const pageID = Number(pathName.substring(index + 1, pathName.length))
      // console.log(pageID)
      // let trackId
      const vm = this
      getClientAudioList(pageID)
        .then((res) => {
          // console.log(res)
          vm.channel_episodes = res.data.data.map((episode, index) => {
            // eslint-disable-next-line camelcase
            const { publishedTime, timeLength } = episode
            episode.updated_at = parseDate(publishedTime)
            episode.timeLength = parseTrackTime(timeLength)
            episode.num = index < 9 ? `0${index + 1}` : `${index + 1}`

            return episode
          })
          // console.log(formatChannelEpisodes)

          this.sortClass(vm.channel_episodes, 'add')
        })
    },
    fetchBorrowRecords () {
      getBorrowRecords()
        .then(res => {
          // console.log(res.data)
          const borrowTime = localStorage.getItem('borrowTime')
          if (res.data.length === 0 && borrowTime !== null) {
            localStorage.removeItem('borrowTime')
          }
          this.setBorrowRecord(res.data)
          this.isLoading = false
        })
        .catch((err) => {
          console.log(err)
          this.isLoading = false
          console.log(err.response.status)
          // if (err.response.status === 401) {
          //   this.getBorrowToken(id)
          // }
        })
    },
    getAudio (track, index) {
      const vm = this

      // console.log('1: getAudio')
      // console.log(this.courseInfo.id)
      const coursePathname = window.location.pathname
      if (vm.courseInfo.id !== vm.channelID) {
        const courseInfo = {
          id: vm.channelID,
          title: vm.title,
          author: vm.author_title,
          imgCover: vm.imgCover,
          pathname: coursePathname
        }
        this.setCourseInfo(courseInfo)
      }
      this.setAudioPlayList()
      this.trackInfo.trackId === track.id ? this.togglePlay() : this.setTrack(track)
    },
    setAudioPlayList () {
      const parseChannelEpisodes = this.channel_episodes.filter((episode) => {
        return episode.status !== false
      })
      // console.log(parseChannelEpisodes)
      if (this.isBorrowed) {
        this.setAudioList(parseChannelEpisodes)
      } else {
        const parseFreeChannelEpisodes = parseChannelEpisodes.filter((episode) => {
          return episode.free === true
        })
        // console.log(parseFreeChannelEpisodes)
        this.setAudioList(parseFreeChannelEpisodes)
      }
    },
    setTrack (track) {
      const borrowTime = localStorage.getItem('borrowTime')
      if (borrowTime !== null && !track.free) {
        console.log('check time')
        const timeNow = new Date().getTime()
        const borrowTimeObj = JSON.parse(localStorage.getItem('borrowTime'))
        // console.log(borrowTimeObj.timeout)
        if (timeNow > borrowTimeObj.timeout) {
          returnBorrowCourse(borrowTimeObj.id)
            .then(res => {
              // console.log(res.data)
              this.fetchBorrowRecords()
              this.getBorrowQuantity(this.toBChannelID)
              this.$toast.show('您尚未借聽課程，無法收聽喔！', 2000)
              localStorage.removeItem('borrowTime')
            })
            .catch((err) => {
              // console.log(err)
              localStorage.removeItem('borrowTime')
              if (err.response.status === 404) {
                this.fetchBorrowRecords()
                this.getBorrowQuantity(this.toBChannelID)
              }
              if (err.response.status === 422) {
                window.location.reload()
              }
              this.$toast.show('您尚未借聽課程，無法收聽喔！', 2000)
            })
          return
        }
      }
      console.log('2: setTrack')
      const indexOfpalyList = this.trackList.findIndex(i => i.id === track.id)
      // console.log(indexOfpalyList)
      const trackObj = {
        trackId: track.id,
        trackTitle: track.title,
        trackIsFree: track.free,
        trackIndex: indexOfpalyList
      }

      this.setTrackInfo(trackObj)
        .then(() => {})
        .catch((err) => {
          this.$toast.show('您尚未借聽課程，無法收聽喔！', 2000)
          this.fetchBorrowRecords()
          this.getBorrowQuantity(this.toBChannelID)
          console.log(err)
        })
    },
    togglePlay () {
      this.isPlaying = !this.isPlaying
    },
    async borrowNow () {
      // console.log('borrowNow')
      this.isLoading = true
      const record = await getBorrowRecords()
        .catch((err) => {
          console.log(err)
        })
      // console.log(record.data)
      if (record.data.length !== 0) {
        const borrowID = record.data[0].id
        const courseID = record.data[0].client_asset.channel_id
        await returnBorrowCourse(borrowID)
        this.setPlayer(courseID)
      }
      const borrowObj = {
        client_asset_id: this.toBChannelID
      }
      borrowCourse(borrowObj)
        .then((res) => {
          // console.log(res.data.id)
          const borrowTimeObj = JSON.stringify({
            timeout: new Date().getTime() + 8 * 3600 * 1000,
            id: res.data.id
          })
          localStorage.setItem('borrowTime', borrowTimeObj)
          this.fetchBorrowRecords()
          this.getBorrowQuantity(this.toBChannelID)
          this.$toast.show('借聽成功', 2000)
        })
        .catch((err) => {
          this.isLoading = false
          console.log(err)
          console.log(err.response.status)
          console.log(err.response.data.errors)
          this.borrowErrorText = err.response.data.errors
          this.$toast.show('借聽失敗', 2000)
        })
    },
    getBorrowQuantity (id) {
      getClientCourseData(id)
        .then(res => {
          const data = res.data
          this.borrowQuantity = data.total_copy - data.borrow_records_count
        })
        .catch((err) => {
          console.log(err)
        })
    },
    returnBorrow () {
      // console.log('歸還')
      this.isLoading = true
      let borrowID
      for (let i = 0; i < this.borrowRecord.length; i++) {
        if (this.borrowRecord[i].client_asset.id === this.toBChannelID) {
          borrowID = this.borrowRecord[i].id
          break
        }
      }
      // console.log(borrowID)
      returnBorrowCourse(borrowID)
        .then(res => {
          // console.log(res.data)
          this.fetchBorrowRecords()
          this.getBorrowQuantity(this.toBChannelID)
          this.$toast.show('歸還成功', 2000)
        })
        .catch((err) => {
          console.log(err)
          if (err.response.status === 404) {
            this.fetchBorrowRecords()
            this.getBorrowQuantity(this.toBChannelID)
          }
          if (err.response.status === 422) {
            window.location.reload()
          }
          this.$toast.show('歸還失敗', 2000)
          this.isLoading = false
        })
    },
    resetBorrowErrorText () {
      if (this.isCanBorrow === true) {
        this.borrowErrorText = ''
      }
    },
    setPlayer (id) {
      // console.log(id)
      if (this.courseInfo.id === id) {
        // console.log('remove')
        this.$emit('removea-audio-player')
      }
    },
    showDisabledMessage () {
      this.$toast.show('您尚未借聽課程，無法收聽喔！', 1500)
    }
  },
  beforeDestroy () {
    if (this.openQrcodeCaption) {
      this.closeCaption()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/scss/clients.scss";

.clients_course {
  margin-top: 25px;
  .course_img {
    border-radius: 10px;
    box-shadow: 0 0 15px hsla(0,0%,60%,.1);
  }
}

.bodyCourse {
  background: transparent;
  padding: 40px 0;
}

.course_tabs {
  border-bottom: 1px solid #E6E6E6;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 35px;
  ul {
    align-items: center;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
    margin-bottom: 0px;
    *:not(:last-child) {
      margin-right: 2rem
    }
    li {
      font-weight: 500;
      font-size: 24px;
      line-height: 25px;
      padding-bottom: 10px;
      cursor: pointer;
    }
    .tab_active {
      color: #176E8D;
      border-bottom: 4px solid #176E8D;
    }
  }
}

.course_repertoire {
  .audio_list {
    margin-bottom: 80px;
    >*:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .audio_item {
    display: flex;
    background: rgba(230, 230, 230, 0.5);
    border-radius: 4px;
    .track_btn {
      display: flex;
      flex-direction: column;
      padding: 30px;
      position: relative;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      .button {
        border: 0;
        background-color: transparent;
        &:focus {
          border: 0;
          outline: 0;
        }
      }
      .audition_text {
        font-size: 1.2rem;
        color: #176E8D;
        margin-bottom: 0;
        align-self: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 10px);
      }
      .click_disabled_message {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    }
    .track_content {
      flex: 1 1 auto;;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      .track_title {
        padding-right: 20px;
        align-self: center;
      }
      .track_right {
        font-size: 1.4rem;
        opacity: 0.5;
        display: flex;
        align-self: center;
        .track_date {
          margin-right: 20px;
        }
        .track_length {
          margin-right: 30px;
        }
      }
    }
  }
  .audio_disabled {
    .track_btn .button {
      cursor: default;
    }
    .track_content .track_title {
      color: #000;
      opacity: 0.5;
    }
  }
  .audio_bg_dark {
    background-color: rgb(222, 222, 222);
  }
}

@media screen and (max-width: 767px){
  .course_repertoire .audio_item .track_content {
    display: flex;
    flex-flow: column;
    justify-content: center;
    padding: 10px;
    .track_title {
      padding-right: 0;
      margin-bottom: 10px;
    }
    .track_right {
      font-size: 1.2rem;
    }
    .track_title, .track_right {
      align-self: flex-start;
    }
  }
}

@media screen and (min-width: 768px){
  .course_repertoire .audio_item .track_content {
    .track_right {
      flex: 0 0 180px;
    }
  }
}

@media screen and (max-width: 375px){
  .course_repertoire .audio_item {
    .track_btn {
      padding: 30px 24px;
      align-self: center;
    }
  }
}

@media screen and (min-width: 767px){
  .clients_course {
    display: flex;
    justify-content: space-between;
    > .course_photo {
      flex: 0 0 43%;
      max-width: 43%;
    }
    > .course_info {
      flex: 0 0 50%;
      max-width: 50%;
    }
    .course_info {
      margin-top: 0;
      display: flex;
      flex-direction: column;
      .course_info_title {
        margin-bottom: 16px;
      }
      // .course_info_author {
      //   margin-bottom: 35px;
      // }
      .course_info_group {
        display: flex;
        justify-content: space-between;
        margin-top: auto;
        .course_info_totel {
          flex: 1 1 auto;
          display: block;
          margin-bottom: 0;
          .total {
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 16px;
          }
        }
        .course_info_borrowNow, .course_info_borrowByApp {
          flex: 0 0 50%;
          max-width: 50%;
        }
        .course_info_borrowNow {
          display: block;
          position: relative;
          padding-right: 10px;
        }
        .course_info_borrowByApp {
          padding-left: 10px;
          &.resetPadding {
            padding-left: 0;
          }
        }
        .appOpen_btn {
          padding: 5px 8px;
          background: #FFFFFF;
          border: 1px solid #059BAD;
          box-sizing: border-box;
          width: 100%;
          .pc_btn {
            display: flex;
            justify-content: center;
            color: #059BAD;
            font-size: 16px;
            line-height: 22px;
          }
          .mobile_btn {
            display: none;
          }
        }
        .course_info_share {
          > *:not(:last-child) {
            margin-right: 0px;
            margin-left: 10px;
          }
          >>> .fb, >>> .line {
            display: none;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 997px){
  .clients_course {
    > .course_photo, .course_info {
      flex: 0 0 47%;
      max-width: 47%;
    }
  }
}

@media screen and (min-width: 1280px){
  .clients_course .course_info .course_info_group .course_info_totel .total {
    font-size: 18px;
  }
}

.course_info {
  margin-top: 20px;
  .course_info_title {
    text-align: left;
    font-size: 28px;
    line-height: 40px;
    color: #000;
  }
  .course_info_subtitle {
    font-size: 18px;
    line-height: 25px;
    opacity: 0.6;
    margin-bottom: 16px;
  }
  .course_info_author {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .author_img {
      width: 40px;
      margin-right: 16px;
      & img {
        border-radius: 50%;
      }
    }
    .author_name {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .course_info_course_totel {
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    margin-bottom: 16px;
  }
  .course_info_totel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    .total {
      display: flex;
      font-size: 18px;
      line-height: 25px;
      font-weight: bold;
      > *:not(:last-child) {
        margin-right: 6px;
      }
    }
  }
  .course_info_btnGroup {
    display: flex;
    justify-content: space-between;
    .course_info_borrowNow {
      display: none;
      .error_text {
        width: 100%;
        font-size: 12px;
        line-height: 14px;
        color: #EA1A00;
        background: #FDF2F1;
        border-radius: 4px;
        padding: 10px 5px;
      }
    }
    .borrow_status {
      background-color: rgb(5,155,173);
      color: white;
      border-radius: 4px;
      padding: 5px 12px;
      display: inline-block;
      width: calc(100% - 10px);
      margin-bottom: 10px;
      text-align: center;
      &.disable {
        background-color: rgba(160, 166, 171, 1);
        width: 100%;
      }
      .loading_icon {
        height: 22px;
      }
      .disable_text {
        margin-bottom: 0;
        font-size: 16px;
        line-height: 22px;
      }
    }
    .loading_status {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
    }
    .borrow_btn {
      background-color: rgb(5,155,173);
      color: white;
      border-radius: 4px;
      font-size: 16px;
      line-height: 22px;
      padding: 6px 12px;
      cursor: pointer;
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
      text-align: center;
    }
  }
  .appOpen_btn {
    background-color: rgb(5,155,173);
    border-radius: 4px;
    padding: 4px 12px;
    cursor: pointer;
    display: inline-block;
    .appOpen_link {
      color: white;
      text-decoration: none;
      font-size: 14px;
      border-radius: 4px;
      display: flex;
      align-items: center;
    }
    .pc_btn {
      display: none;
    }
    .mobile_btn {
      display: flex;
    }
    .appOpen_btn_icon {
      margin-right: 7px;
      & img {
        width: 12px;
      }
    }
  }
  .course_info_share {
    display: flex;
    > *:not(:last-child) {
      margin-right: 10px;
    }
    >>> .share_item {
      display: flex;
      align-items: center;
      padding: 5px 8px;
      border-radius: 4px;
      cursor: pointer;
    }
    >>> .share_icon {
      margin-right:3px;
      display: flex;
      align-items: center;
      & img {
        width: 16px;
      }
    }
    >>> .share_link {
      display: inline-block;
      font-size: 11px;
      color: white;
      position: relative;
      line-height: 16px;
      text-decoration: none;
    }
    >>> .fb {
      background: linear-gradient(180deg,#4a67bd 0,#3952a2);
    }
    >>> .line {
      background: linear-gradient(180deg,#6bdd00 0,#13b700);
    }
  }
}

//Caption_Modal

.caption_modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding-top: 0px;
  z-index: 1000;
}

.caption_close {
  text-align: right;
  .close_btn {
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    border: 0;
  }
  .close_icon {
    width: 20px;
  }
}

.caption_wrap {
  margin: auto;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background-color: #fff;
  overflow: hidden;
}

.caption_qrcode {
  position: relative;
  text-align: center;
  margin-top: 100px;
  .qrcode_bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.caption_text {
  text-align: center;
  margin-top: 50px;
  > * {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 0
  }
}

.caption_group {
  position: relative;
  z-index: 3;
  padding: 25px 35px 45px;
  height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 5px;
    height: 7px;
    padding-right: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgb(219, 220, 221);
    border: 0px none #ffffff;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  .client_description {
    >>> h2 {
      font-size: 24px;
      line-height: 33px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    >>> p {
      font-size: 16px;
      line-height: 26px;
      margin-bottom: 30px;
    }
  }
}

.client_overlay {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.65);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: -1;
}

.fade-enter-active {
  transition: opacity .8s
}

.fade-leave-active {
  transition: opacity .4s
}

.fade-enter,.fade-leave-to {
  opacity: 0;
}

.fadeIn_header{
  animation: fadeIn 1s;
}

/*頭像動畫*/
@-webkit-keyframes fadeIn{
  0% { opacity: 0 }
  50%{ opacity: 0.5 }
  100%{ opacity: 1}
}

@keyframes fadeIn{
  0% { opacity: 0 }
  50%{ opacity: 0.5 }
  100%{ opacity: 1}
}

@media screen and (min-width: 576px){
  .caption_modal {
    padding: 100px 0;
  }
  .caption_wrap {
    border-radius: 10px;
    width: 450px;
  }
  .caption_group {
    height: calc(100vh - 200px);
    padding: 25px 35px;
  }
}
//Caption_Modal END
</style>



// WEBPACK FOOTER //
// src/components/views/clients/ClientsCourse/index.vue